type Props = {
  children: React.ReactNode;
};

/**
 * The AuthRefreshProvider is now a no-op since we only use access tokens.
 * Kept for backward compatibility.
 *
 * @param children The children to render.
 */
export const AuthRefreshProvider = ({ children }: Props) => {
  return children;
};
